
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import React, { FC, useState, useEffect } from 'react'
import { tawreedTranslationService } from '../../../../common/translations';
import { TawreedFormField, TawreedInputFile, TawreedInputText } from '../../../../common';
import { TawreedFile } from '../../../upload';
import { StoreProductSellerAutoCompleteComponent } from '../../../catalog/store-products/presentaion/components';
import { AuthUtils } from '../../../auth/domain';
import { StoreProductDto } from '../../../catalog/store-products/domain';

export interface PostImageUploadDialogProps {
    visible: boolean;
    type?: 'IMAGE' | 'INTERNAL_LINK';
    hide: () => void;
    storeId: number;
    accept: (data: { file?: File, titleEn: string, titleAr: string, type: string, subType?: string ,storeProduct?: StoreProductDto }) => void;

}

export const PostUploadDialog: FC<PostImageUploadDialogProps> = ({ visible, hide, accept, type, storeId }) => {


    const [dialogState, setDialogState] = useState<{
        file: File | undefined,
        titleEn: string | undefined,
        titleAr: string | undefined,
        type: string |undefined,
        subType: string |undefined,
        storeProduct: StoreProductDto | undefined
    }>({
        file: undefined,
        titleEn: undefined,
        titleAr: undefined,
        type: type,
        subType: type === 'INTERNAL_LINK' ? 'STORE_PRODUCT' : undefined,
        storeProduct: undefined
    });

    useEffect(() => {

        setDialogState({
            file: undefined,
            titleEn: undefined,
            titleAr: undefined,
            type: type,
            subType: type === 'INTERNAL_LINK' ? 'STORE_PRODUCT' : undefined,
            storeProduct: undefined
        })
    }, [visible]);

    console.log("ds",type);

    const PostImageUploadDialogFooter = () => {
        return (<div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon="pi pi-times" onClick={hide} className="p-button-text" /*disabled={dialogState.loading}*/ />
            <Button onClick={() => {
                console.log("accept",{
                    file: dialogState.file,
                    titleEn: dialogState.titleEn!,
                    titleAr: dialogState.titleAr!,
                    type: dialogState.type!,
                    subType: dialogState.subType,
                    storeProduct: dialogState.storeProduct
                });
                accept({
                    file: dialogState.file,
                    titleEn: dialogState.titleEn!,
                    titleAr: dialogState.titleAr!,
                    type: dialogState.type!,
                    subType: dialogState.subType,
                    storeProduct: dialogState.storeProduct
                });
                hide();
            }} label={tawreedTranslationService.translate('lbl_accept')} icon="pi pi-check" disabled={!dialogState || (!dialogState.file && !dialogState.storeProduct) || !dialogState.titleEn|| !dialogState.titleAr}
            // loading={dialogState.loading}
            />
        </div>);
    }

    return (
        <Dialog style={{}} header={tawreedTranslationService.translate('lbl_posts_images_add_image')} visible={visible} footer={<PostImageUploadDialogFooter />} onHide={hide}
         draggable={false} position="top" closable={true} closeOnEscape={true}>
            {(type && type === 'IMAGE') &&
            <form className="formgrid grid" >
                <React.Fragment>
                    <TawreedFormField title="lbl_posts_images_image" className="field col-12" name="file">
                        <TawreedInputFile render='standalone'  name="file" accept='image/*' onChange={
                            (e: TawreedFile | undefined) => setDialogState({ ...dialogState, file: e && e.value instanceof File ? e.value : dialogState.file })
                        } />
                    </TawreedFormField>
                    <TawreedFormField name="titleEn" title="lbl_posts_images_titleEn" className="field col-12 md:col-12 mt-3">
                        <TawreedInputText dir="ltr" value={dialogState?.titleEn} name="titleEn" rules={{ required: "msg_field_is_required" }} render="standalone" onChange={(e) => {
                            setDialogState({ ...dialogState, titleEn: e.target.value });
                        }} />

                    </TawreedFormField>
                    <TawreedFormField name="titleAr" title="lbl_posts_images_titleAr" className="field col-12 md:col-12 mt-3">
                        <TawreedInputText dir="rtl" value={dialogState?.titleAr} name="titleAr" rules={{ required: "msg_field_is_required" }} render="standalone" onChange={(e) => {
                            setDialogState({ ...dialogState, titleAr: e.target.value });
                        }} />

                    </TawreedFormField>

                </React.Fragment>
            </form>
            }
            {(type && type === 'INTERNAL_LINK') &&
            <form className="formgrid grid" >
                <React.Fragment>
                     <TawreedFormField name="storeProduct" title={"lbl_store_products_quantity_limitation_title"} className="field col-6 lg:col-6 md:col-6">
                    
                                                <StoreProductSellerAutoCompleteComponent
                                                    //storeId={.store?.partnerId}
                                                    partnerId={storeId}
                                                    autoCompleteName="storeProduct"
                                                    autoCompleteField={AuthUtils.current().language === "en" ? "titleEn" : "titleAr"}
                                                    autoCompleteRules={{ required: "msg_field_is_required" }}
                                                    autoCompleteDisabled={storeId ? false : true}
                                                    autoCompleteRender="form"
                                                    autoCompleteOnSelect={e => {
                                                        const p = e.value as StoreProductDto;
                                                        if (p) {
                                                            setDialogState({ ...dialogState, storeProduct: p, titleAr: p.titleAr, titleEn: p.titleEn })
                                                        } else {
                                                            setDialogState({ ...dialogState, storeProduct: undefined, titleAr: undefined, titleEn: undefined })
                                                        }
                                                    }} />
                                            </TawreedFormField>
                    <TawreedFormField name="titleEn" title="lbl_posts_images_titleEn" className="field col-12 md:col-12 mt-3">
                        <TawreedInputText dir="ltr" value={dialogState?.titleEn} name="titleEn" rules={{ required: "msg_field_is_required" }} render="standalone" onChange={(e) => {
                            setDialogState({ ...dialogState, titleEn: e.target.value });
                        }} />

                    </TawreedFormField>
                    <TawreedFormField name="titleAr" title="lbl_posts_images_titleAr" className="field col-12 md:col-12 mt-3">
                        <TawreedInputText dir="rtl" value={dialogState?.titleAr} name="titleAr" rules={{ required: "msg_field_is_required" }} render="standalone" onChange={(e) => {
                            setDialogState({ ...dialogState, titleAr: e.target.value });
                        }} />

                    </TawreedFormField>

                </React.Fragment>
            </form>
            }
        </Dialog>
    )
}
